import React, { FC, ReactElement } from "react";
import { Button } from "./styles";

interface IProps {
  title: string;
  url: string;
}

const ApplyButton: FC<IProps> = ({
  title,
  url = "#",
}: IProps): ReactElement => {
  return (
    <Button href={url} target="_blank" rel="noopener noreferrer">
      {title}
    </Button>
  );
};

export default ApplyButton;
